import React from 'react';
import './EditorPreview.css';

/**
 * EditorPreview — GERÇEK çizim editörünü salt-okunur ön izleme olarak gömen iframe.
 *
 * Ayrı bir (sapabilen) önizleyici bakımı yerine, editörün TAM render pipeline'ını
 * (deserialize + hydrate + tesisat/wire/layout rebuild) iframe içinde kullanır →
 * ön izleme editörle birebir aynı ve format değişse de asla sapmaz.
 *
 * iframe ayrı bir tarayıcı context'i olduğu için Redux store + WebGL context
 * otomatik izole olur (global store'a dokunmadan N kart yan yana render edilebilir).
 *
 * Kullanım:
 *   <EditorPreview src={jbzUrl} height={320} />                  // doğrudan .jbz URL
 *   <EditorPreview projectId={id} attachCat="jbz" attachFile={name} />  // kayıtlı ek
 */
export default function EditorPreview({
  src,
  projectId,
  attachCat,
  attachFile,
  height = 320,
  className = '',
  title = 'Proje önizleme',
}) {
  let url = null;
  if (src) {
    url = `/app?preview=1&src=${encodeURIComponent(src)}`;
  } else if (projectId) {
    const params = new URLSearchParams({ preview: '1' });
    if (attachCat) params.set('attachCat', attachCat);
    if (attachFile) params.set('attachFile', attachFile);
    url = `/app/${projectId}?${params.toString()}`;
  }

  if (!url) return null;

  return (
    <div className={`editor-preview ${className}`} style={{ height }}>
      <iframe
        className="editor-preview-iframe"
        src={url}
        title={title}
        loading="lazy"
      />
    </div>
  );
}
